import { memo } from "react";

import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

// -----------------------------------------------------------------------------

const OrganizationFindingsInboxLoading = memo(
  function OrganizationFindingsInboxLoading(): JSX.Element {
    return (
      <Box padding={2} textAlign="center">
        <CircularProgress />
      </Box>
    );
  }
);

export default OrganizationFindingsInboxLoading;

// -----------------------------------------------------------------------------
